import React from 'react';

import { Label as FormLabel, withSubmission } from '../container/Form.jsx';
import { Indicator as LoadingIndicator, Fullscreen as LoadingFull } from '../container/Loading.jsx';
import Arrows from '../input/Arrows.jsx';
import { Input } from '../input/Text.jsx';

function BackgroundOverlay(props) {
    let opacity = 1;
    let zIndex = 20;
    if (props.nested) {
        opacity = 0.9;
        zIndex = 43;
    }
    return (
        <div className="overlay__container overlay--dark overlay--active" style={{ cursor: 'pointer', opacity: opacity, zIndex: zIndex }} onClick={props.onClick} />
    );
}

function Popup(props) {
    let className = 'popup--cont popup--active';
    switch (props.type) {
        case 'container':
            className += ' form__container';
            break;
        case 'popup':
            className += ' form--popup';
            break;
    }
    if (props.nested) {
        className += ' popup--active--nested';
    }
    if (props.className) {
        className += ` ${props.className}`;
    }
    let backgroundClickHandler;
    if (props.backgroundClick != false) {
        backgroundClickHandler = props.onClose;
    }
    return (
        <React.Fragment>
            <BackgroundOverlay nested={props.nested} onClick={backgroundClickHandler} />
            <div className={className}>
                <a href="#" className="overlay__close" onClick={e => {
                    if (e) { e.preventDefault(); }
                    props.onClose();
                }}><span className="i i--close" /></a>
                {props.children}
            </div>
        </React.Fragment>
    )
}

let _GalleryContactInst;
class GalleryContact extends React.Component {
    constructor(props) {
        super(props);

        const user = props.user || {};
        this.state = {
            Email: user.Email,
            Name: user.Name && user.Name.Full
        };

        this.inputConfig = {
            color: 'light',
            size: 'medium',
            style: 'outline'
        };

        this.handleClose = this.handleClose.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        _GalleryContactInst = true;
    }

    componentWillUnmount() {
        _GalleryContactInst = undefined;
    }

    handleClose(event) {
        if (event) {
            event.preventDefault();
        }
        if (!this.state.loading && this.props.onClose) {
            this.props.onClose();
        }
    }

    handleSubmit(data, callback) {
        if (this.state.loading) {
            return;
        }
        const component = this;
        component.setState({
            loading: true
        });
        const galleryId = component.props.data.GalleryId;
        const postData = {
            Email: data.Email,
            GalleryId: galleryId,
            Message: data.Message,
            Name: data.Name
        }
        Artcloud.api.post(
            Artcloud.url.vendor.marketplace.inquiries.post(),
            postData,
            function () {
                if (!_GalleryContactInst) {
                    return;
                }
                component.setState({
                    loading: false
                });
                if (callback) {
                    callback(true, 'Your message has been sent. Thank you!');
                }
            },
            function (jqXHR) {
                if (!_GalleryContactInst) {
                    return;
                }
                component.setState({
                    loading: false
                });
                if (!callback) {
                    return;
                }
                callback(false, 'There was a problem sending your message. Please wait a moment and try again.', jqXHR);
            }
        );
    }

    render() {
        return (
            <Popup className="text--center popup--gallery" type='container' onClose={this.handleClose}>
                <GalleryContactForm
                    action="form__inner"
                    data={this.props.data}
                    initialState={this.state}
                    inputConfig={this.inputConfig}
                    loading={this.state.loading}
                    onSubmit={this.handleSubmit} />
                {
                    this.state.loading &&
                    <LoadingFull style={{ backgroundColor: '#222' }} />
                }
            </Popup>
        );
    }
}

function GalleryProspectArtists(props) {
    return (
        <Popup className="text--center" type='container' onClose={props.onClose}>
            <div><strong>{(props.d.Company || `<No Company> (${props.d.GalleryId})`) + ` (${props.d.GalleryId})`} Artists</strong></div>
            <br />
            <div><strong className="cursor-pointer"
                onClick={() => Artcloud.util.copyToClipboard(props.d.Artists.map(x =>
                    `${x.Name} - ${Artcloud.url.mkt.baseUrl}artist/${x.Slug}`).join('\r\n'))}>Copy to Clipboard</strong></div>
            <br />
            {props.d.Artists.map(x => <div key={x.ArtistId}>
                <a className="c-white" target="_blank" href={`/artist/${x.Slug}`}>{x.Name}</a>
            </div>)}
        </Popup>
    )
}

function _GalleryContactForm(props) {
    const data = props.data || {};
    return (
        <div className="form__inner__content">
            <h4 className="form--signup__header">Get in touch with <strong>{data.Company}</strong>!</h4>
            <div className="contact__info">
                <FormLabel className="contact__info__title" display={<strong>Contact information</strong>} />
                {
                    data.Address &&
                    <FormLabel display={<React.Fragment>Address: <strong>{data.Address}</strong></React.Fragment>} />
                }
                {
                    data.Phone &&
                    <FormLabel display={<React.Fragment>Phone Number: <strong>{data.Phone}</strong></React.Fragment>} />
                }
            </div>
            <br />
            <FormLabel className="contact__info__title text--center" display={<React.Fragment>Send <strong>{data.Company}</strong> a message</React.Fragment>} />
            <Input
                config={props.inputConfig}
                disabled={props.loading || props.success}
                name="Name"
                placeholder="Name"
                required
                type="text"
                value={props.state.Name}
                onChange={props.onChange} />
            <Input
                config={props.inputConfig}
                disabled={props.loading || props.success}
                name="Email"
                placeholder="Email Address"
                required
                type="email"
                value={props.state.Email}
                onChange={props.onChange} />
            <Input
                config={{ color: 'light', size: 'small', style: 'outline' }}
                disabled={props.loading || props.success}
                name="Message"
                placeholder="Enter your message here..."
                required
                textArea={true}
                type="text"
                value={props.state.Message}
                onChange={props.onChange} />
            <Arrows
                config={{ color: 'light' }}
                disabled={props.loading || props.success}
                display="Submit"
                form={true} />
        </div>
    );
}
const GalleryContactForm = withSubmission(_GalleryContactForm);

let _ListArtworkAddInst;
class ListArtworkAdd extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true
        };

        this._handleNameInputRef = this._handleNameInputRef.bind(this);
        this._updateListState = this._updateListState.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleCreateFormShow = this.handleCreateFormShow.bind(this);
        this.handleCreateSubmit = this.handleCreateSubmit.bind(this);
        this.handleKeyUp = this.handleKeyUp.bind(this);
        this.handleListAdd = this.handleListAdd.bind(this);
        this.handleListDelete = this.handleListDelete.bind(this);
    }

    componentDidMount() {
        _ListArtworkAddInst = true;

        if (!this.props.data) {
            return;
        }
        const component = this;
        component.request = Artcloud.api.get(
            Artcloud.url.vendor.marketplace.lists.get(),
            { dir: 1, order: 2, type: 4 },
            function (responseData) {
                component.request = null;

                responseData.Lists.forEach(function (d) {
                    if (d.ArtIds.indexOf(component.props.data.ArtId) >= 0) {
                        d.IsArtInList = true;
                    }
                });
                component.setState({
                    lists: responseData.Lists,
                    loading: false
                });
            },
            function (jqXHR, textStatus) {
                component.request = null;
                component.setState({
                    loading: false
                });
                if (jqXHR.status != 401) {
                    Artcloud.api.mktfail(jqXHR, textStatus);
                }
            }
        );
    }

    componentWillUnmount() {
        _ListArtworkAddInst = undefined;

        if (this.request) {
            this.request.abort();
            this.request = null;
        }
    }

    _handleNameInputRef(ref) {
        this.nameInputRef = ref;
    }

    _updateListState(listId, state) {
        const lists = this.state.lists;
        let temp;
        for (let i = 0; i < lists.length; i++) {
            temp = lists[i];
            if (temp.ListId != listId) {
                continue;
            }
            temp.IsArtInList = state;
            break;
        }
        this.setState({
            lists: lists
        });
    }

    handleChange(name, value) {
        this.setState({
            [name]: value
        });
    }

    handleClose(event) {
        if (event) {
            event.preventDefault();
        }
        if (this.props.onClose) {
            this.props.onClose();
        }
    }

    handleCreateFormShow(event) {
        if (event) {
            event.preventDefault();
        }
        this.setState({
            createForm: true
        });
    }

    handleCreateSubmit(event) {
        if (event) {
            event.preventDefault();
        }
        if (!this.state.Name || !this.state.Name.length || this.state.creating) {
            return;
        }
        const component = this;
        component.setState({
            creating: true
        });
        if (component.nameInputRef) {
            component.nameInputRef.blur();
        }
        Artcloud.api.post(
            Artcloud.url.vendor.marketplace.lists.post(),
            { Name: component.state.Name },
            function (responseData) {
                if (!_ListArtworkAddInst) {
                    return;
                }
                const artId = component.props.data.ArtId;
                responseData.ArtIds.push(artId);
                responseData.IsArtInList = true;

                const lists = component.state.lists;
                lists.push(responseData);
                component.setState({
                    createForm: undefined,
                    creating: false,
                    lists: lists,
                    Name: undefined
                });

                Artcloud.api.put(Artcloud.url.vendor.marketplace.lists.art.put(responseData.ListId, artId));
            },
            function () {
                if (!_ListArtworkAddInst) {
                    return;
                }
                component.setState({
                    creating: false
                });
            }
        )
    }

    handleKeyUp(event) {
        if (event.keyCode == 13) {
            this.handleCreateSubmit();
        }
    }

    handleListAdd(listId) {
        const component = this;
        Artcloud.api.put(
            Artcloud.url.vendor.marketplace.lists.art.put(listId, component.props.data.ArtId),
            null,
            function () {
                if (!_ListArtworkAddInst) {
                    return;
                }
                component._updateListState(listId, true);
            }
        );
    }

    handleListDelete(listId) {
        const component = this;
        Artcloud.api.del(
            Artcloud.url.vendor.marketplace.lists.art.del(listId, component.props.data.ArtId),
            null,
            function () {
                if (!_ListArtworkAddInst) {
                    return;
                }
                component._updateListState(listId, undefined);
            }
        );
    }

    render() {
        const data = this.props.data || {};
        let image;
        if (data.Image && data.Image.MediumUrl && data.Image.MediumUrl.length) {
            image = data.Image.MediumUrl;
        }
        let createFormClassName = 'tolist__item tolist__create';
        if (this.state.createForm) {
            createFormClassName += ' tolist__create--active';
        }
        return (
            <Popup className="popup--tolist" nested={this.props.nested} type='popup' onClose={this.handleClose}>
                <div className="popup--tolist__img">
                    <img src={image} alt={data.Title} />
                </div>
                <div className="popup--tolist__content">
                    <div className="popup--tolist__head popup--tolist__child">
                        <h4 className="popup--tolist__title">Save to list</h4>
                        <p className="popup--tolist__text">Add this artwork to a list and share your collections with friends.</p>
                    </div>
                    <div className="tolist__container popup--tolist__child">
                        <h6 className="tolist__item">My Favorites</h6>
                        <div className="tolist__items">
                            {
                                this.state.loading &&
                                <LoadingIndicator />
                            }
                            {
                                !this.state.loading &&
                                this.state.lists &&
                                this.state.lists.map((d) => <ListArtworkAddRow key={d.ListId} data={d} onAdd={this.handleListAdd} onDelete={this.handleListDelete} />)
                            }
                        </div>
                        <span className={createFormClassName}>
                            <span className="tolist__create__text" onClick={this.handleCreateFormShow}>Create New List</span>
                            <span className="tolist__create__input">
                                <Input
                                    config={{ size: 'small', style: 'outline', type: 'btn' }}
                                    name="Name"
                                    placeholder="Enter name of list"
                                    value={this.state.Name}
                                    onChange={this.handleChange}
                                    onKeyUp={this.handleKeyUp}
                                    onRef={this._handleNameInputRef}>
                                    <Arrows display="Create" onClick={this.handleCreateSubmit} />
                                </Input>
                            </span>
                        </span>
                    </div>
                    <div className="popup--tolist__foot popup--tolist__child">
                        <div className="art__info">
                            {
                                data.Artist &&
                                <span className="art__user">{data.Artist.Name}</span>
                            }
                            <span className="art__title">{data.Title}</span>
                            <span className="art__details">
                                {
                                    data.Dimensions &&
                                    data.Dimensions.Display &&
                                    <span>{data.Dimensions.Display.Formatted}</span>
                                }
                                <span>{data.DisplayPrice}</span>
                                {
                                    data.Gallery &&
                                    <span>{data.Gallery.Company}</span>
                                }
                            </span>
                        </div>
                    </div>
                </div>
            </Popup>
        );
    }
}

class ListArtworkAddRow extends React.Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(event) {
        if (event) {
            event.preventDefault();
        }
        if (this.props.data.IsArtInList) {
            this.props.onDelete(this.props.data.ListId);
        } else {
            this.props.onAdd(this.props.data.ListId);
        }
    }

    render() {
        const data = this.props.data || {}
        let className = 'tolist__item';
        if (data.IsArtInList) {
            className += ' tolist__item--active';
        }
        return (
            <span className={className} onClick={this.handleClick}>
                <React.Fragment>{data.Name} ({data.ArtIds ? data.ArtIds.length : 0})</React.Fragment>
                <span className="tolist__item__control">
                    <span className="i i--heart" />
                    <span className="tolist__item__remove">Remove</span>
                </span>
            </span>
        );
    }
}

export {
    GalleryContact,
    GalleryProspectArtists,
    ListArtworkAdd,
    Popup
};